module.exports = __webpack_public_path__ + "img/Atman_białe.69f9c7d9.webp";